import React from 'react';
import ManagementPage from './ManagementPage';
export default function FinancialInstitutionsPage() { return <ManagementPage resource="institutions" />; }
